// Browsers hold audio until the viewer interacts with the page. While the
// phone has handed sound to this TV and the player has Sound on, the first
// click, tap or key press (a TV remote's OK) unlocks it; until then a small
// prompt says so. Nothing shows when sound is off. See sfx.ts.
import { useEffect, useState } from 'react';
import { soundLocked, subscribeSound, tvSfx, unlockSound } from './sfx';

export default function SoundUnlock({ revision }: { revision: unknown }) {
  const [, setTick] = useState(0);
  useEffect(() => subscribeSound(() => setTick((tick) => tick + 1)), []);
  useEffect(() => {
    const unlock = () => {
      if (tvSfx.soundOn()) unlockSound();
    };
    window.addEventListener('pointerdown', unlock);
    window.addEventListener('keydown', unlock);
    return () => {
      window.removeEventListener('pointerdown', unlock);
      window.removeEventListener('keydown', unlock);
    };
  }, []);
  // `revision` re-renders this when a snapshot changes the sound settings.
  void revision;
  if (!tvSfx.soundOn() || !soundLocked()) return null;
  return (
    <button type="button" className="sound-unlock" onClick={unlockSound}>
      Sound is on. Press OK or click to hear it on the TV.
    </button>
  );
}
